import React, { useState } from 'react';
import { Input, Button, HStack, Text } from '@chakra-ui/react';

const EditQuestionForm = ({ question, onSave, onCancel }) => {
  const [text, setText] = useState(question.text);
  const [error, setError] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!text.trim()) {
      setError('Question text is required');
      return;
    }
    if (text.trim().length < 3) {
      setError('Question must be at least 3 characters');
      return;
    }
    onSave({ text });
  };

  return (
    <form onSubmit={handleSubmit}>
      <Input
        type="text"
        value={text}
        onChange={e => {
          setText(e.target.value);
          setError('');
        }}
        placeholder="Question text"
        mb={2}
        isInvalid={!!error}
      />
      {error && <Text fontSize="sm" color="red.500" mb={2}>{error}</Text>}
      <HStack>
        <Button type="submit" colorScheme="teal" size="sm">
          Update Question
        </Button>
        <Button onClick={onCancel} size="sm">
          Cancel
        </Button>
      </HStack>
    </form>
  );
};

export default EditQuestionForm;
